var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320 355.688C320 424.219 264.235 480 195.689 480H89.737C49.143 480 13.253 454.125 0.409 415.625C-0.981 411.437 1.284 406.906 5.472 405.5C9.691 404.125 14.191 406.375 15.597 410.562C26.253 442.531 56.05 464 89.737 464H195.689C255.407 464 304 415.406 304 355.688S255.407 247.375 195.689 247.375H8.003C5.55 247.375 3.238 246.25 1.722 244.313C0.206 242.406 -0.34 239.875 0.222 237.5L48.222 38.125C49.097 34.531 52.3 32 56.003 32H280C284.422 32 288 35.594 288 40S284.422 48 280 48H62.3L18.159 231.375H195.689C264.235 231.375 320 287.156 320 355.688Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.c65e7ccdf7446afaac5837bc3acce5c4.svg";
export { ForwardRef as ReactComponent };